import { Link } from "react-router-dom";
import { PRIVACY_PAGE, TERMS_PAGE, FAQ_PAGE, DEMO_PAGE, PRICING_PAGE, ACUERDO_PAGE } from "@/constants/testIds";

export function Footer() {
  return (
    <footer className="px-6 md:px-12 py-8 border-t border-petroleum/10 flex flex-col sm:flex-row items-center justify-between gap-3 max-w-6xl mx-auto">
      <p className="text-xs text-charcoal/50">© {new Date().getFullYear()} CERH. Todos los derechos reservados.</p>
      <div className="flex items-center gap-4">
        <Link data-testid={`${DEMO_PAGE.navLink}-footer`} to="/demo" className="text-xs text-charcoal/50 hover:text-petroleum underline transition-colors">
          Ver demo
        </Link>
        <Link data-testid={`${PRICING_PAGE.navLink}-footer`} to="/precios" className="text-xs text-charcoal/50 hover:text-petroleum underline transition-colors">
          Precios
        </Link>
        <Link data-testid={TERMS_PAGE.footerLink} to="/terminos" className="text-xs text-charcoal/50 hover:text-petroleum underline transition-colors">
          Términos de Uso
        </Link>
        <Link data-testid={FAQ_PAGE.footerLink} to="/faq" className="text-xs text-charcoal/50 hover:text-petroleum underline transition-colors">
          FAQ
        </Link>
        <Link data-testid={PRIVACY_PAGE.footerLink} to="/aviso-privacidad" className="text-xs text-charcoal/50 hover:text-petroleum underline transition-colors">
          Aviso de Privacidad
        </Link>
        <Link data-testid={ACUERDO_PAGE.footerLink} to="/acuerdo-tratamiento-datos" className="text-xs text-charcoal/50 hover:text-petroleum underline transition-colors">
          Acuerdo de Tratamiento de Datos
        </Link>
      </div>
    </footer>
  );
}
